module.exports = __webpack_public_path__ + "img/emptymock.ac610045.svg";